import React from 'react';

const Warning = () => (
  <svg
    width="26"
    height="27"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2238_51948"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="27"
    >
      <rect y="0.400391" width="26" height="26" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2238_51948)">
      <path
        d="M2.95365 23.1504C2.75503 23.1504 2.57448 23.1007 2.41198 23.0014C2.24948 22.9021 2.12309 22.7712 2.03281 22.6087C1.94253 22.4462 1.89288 22.2702 1.88385 22.0806C1.87483 21.891 1.92448 21.7059 2.03281 21.5254L12.0536 4.19206C12.162 4.0115 12.3019 3.87609 12.4734 3.78581C12.645 3.69553 12.821 3.65039 13.0016 3.65039C13.1821 3.65039 13.3582 3.69553 13.5297 3.78581C13.7012 3.87609 13.8411 4.0115 13.9495 4.19206L23.9703 21.5254C24.0786 21.7059 24.1283 21.891 24.1193 22.0806C24.1102 22.2702 24.0606 22.4462 23.9703 22.6087C23.88 22.7712 23.7536 22.9021 23.5911 23.0014C23.4286 23.1007 23.2481 23.1504 23.0495 23.1504H2.95365ZM4.8224 20.9837H21.1807L13.0016 6.90039L4.8224 20.9837ZM13.0016 19.9004C13.3085 19.9004 13.5658 19.7966 13.7734 19.5889C13.9811 19.3813 14.0849 19.124 14.0849 18.8171C14.0849 18.5101 13.9811 18.2528 13.7734 18.0452C13.5658 17.8375 13.3085 17.7337 13.0016 17.7337C12.6946 17.7337 12.4373 17.8375 12.2297 18.0452C12.022 18.2528 11.9182 18.5101 11.9182 18.8171C11.9182 19.124 12.022 19.3813 12.2297 19.5889C12.4373 19.7966 12.6946 19.9004 13.0016 19.9004ZM13.0016 16.6504C13.3085 16.6504 13.5658 16.5466 13.7734 16.3389C13.9811 16.1313 14.0849 15.874 14.0849 15.5671V12.3171C14.0849 12.0101 13.9811 11.7528 13.7734 11.5452C13.5658 11.3375 13.3085 11.2337 13.0016 11.2337C12.6946 11.2337 12.4373 11.3375 12.2297 11.5452C12.022 11.7528 11.9182 12.0101 11.9182 12.3171V15.5671C11.9182 15.874 12.022 16.1313 12.2297 16.3389C12.4373 16.5466 12.6946 16.6504 13.0016 16.6504Z"
        fill="#CB2C2C"
      />
    </g>
  </svg>
);

export default Warning;
